import Box from "@mui/material/Box";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import React from "react";

export const StudioSidebarItems = {
    PEOPLE: 'people',
    CHAT: 'chat',
    INVITE: 'invite',
}

const V2StudioSidebar = ({setSidebarItemSelected, sidebarItemSelected}) => {

    const mediaBarItemStyle = (isItemSelected) => {

        return {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: "10px 8px",
            alignItems: 'center',
            gap: '4px',
            alignSelf: 'stretch',
            background: isItemSelected ? "var(--app-bg-subtle)" : "transparent",
            borderRadius: '10px',
            border: isItemSelected ? '1px solid var(--app-border-muted)' : '1px solid transparent',
            transition: 'background-color 0.12s ease, border-color 0.12s ease',
            "&:hover": {
                background: "var(--app-bg-subtle)",
                borderColor: 'var(--app-border-subtle)',
                cursor: 'pointer',
            }
        }

    }

    const mediaBarItemTextStyle = (isItemSelected: boolean) => ({
        color: isItemSelected ? "var(--app-text-primary)" : "var(--app-text-muted)",
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '14px',
        letterSpacing: '0.2px',
        userSelect: 'none',
    })

    const handleClick = (item) => {
        if (sidebarItemSelected === item) {
            setSidebarItemSelected(null);
            return;
        }
        setSidebarItemSelected(item);
    }

    return <>
        <Box sx={mediaBarItemStyle(sidebarItemSelected === StudioSidebarItems.PEOPLE)} onClick={() => {
            handleClick(StudioSidebarItems.PEOPLE)
        }}>
            <Box sx={{width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <PeopleOutlinedIcon sx={{ fontSize: 21, color: sidebarItemSelected === StudioSidebarItems.PEOPLE ? 'var(--app-text-primary)' : 'var(--app-text-muted)' }} />
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === StudioSidebarItems.PEOPLE)}>
                People
            </Box>
        </Box>
        <Box sx={mediaBarItemStyle(sidebarItemSelected === StudioSidebarItems.CHAT)} onClick={() => {
            handleClick(StudioSidebarItems.CHAT)
        }}>
            <Box sx={{width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <ChatOutlinedIcon sx={{ fontSize: 21, color: sidebarItemSelected === StudioSidebarItems.CHAT ? 'var(--app-text-primary)' : 'var(--app-text-muted)' }} />
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === StudioSidebarItems.CHAT)}>
                Chat
            </Box>
        </Box>
    </>
}

export default V2StudioSidebar;
